import { useQuery } from '@tanstack/react-query'
import { apiRequest } from '@/lib/queryClient'

export interface ProjectDetails {
  id: string
  name: string
  client_org?: string
  owner_name: string
  description?: string
  roi_config?: any
  roi_summary?: any
  module_completion?: any
  enable_prioritization?: boolean
  include_pricing_screen?: boolean
  export_options_enabled?: boolean
  created_at?: string
}

export function useProjectDetails(projectId: string | undefined, enabled: boolean = true) {
  const query = useQuery<ProjectDetails>({
    queryKey: ['/api/projects', projectId],
    queryFn: async () => {
      if (!projectId) throw new Error('Project ID is required')
      
      return await apiRequest(`/api/projects/${projectId}`)
    },
    enabled: !!projectId && enabled,
    retry: false, // Don't retry on 404s
  })

  return {
    ...query,
    refreshProject: query.refetch
  }
}
